window.addEventListener('load', function () {
  if ($(window).width() < 641) {
    // $('div.pink-promo section').slick({
    //   arrows: false,
    //   autoplay: true,
    //   autoplaySpeed: slickSpeed
    // });
    const lancamentosProdutos = document.querySelector('.product-list');
    mbCarousel(lancamentosProdutos, {
      items: 6,
      fullWidth: true,
      buttons: true,
      dots: false,
      responsive: {
        1360: {
          inherit: true,
          items: 5
        },
        800: {
          dots: false,
          buttons: true,
          items: 2,
          fullWidth: true
        }
      }
    }
    );
    mbCarousel('.quick-links-custom', {
      items: 2,
      dots: true,
      buttons: false,
      fullWidth: true
    });
    mbCarousel('.quick-links-custom.pt-links.links-2', {
      items: 2,
      dots: true,
      buttons: false,
      fullWidth: true
    });
    mbCarousel('div.pink-promo section', {
      items: 1
    });
    // $('.pink-promo section').owlCarousel({
    //     items: 1
    // });

    // $('.quick-links-custom').owlCarousel({
    //     loop: false,
    //     margin: 0,
    //     nav: false,
    //     dots: true,
    //     navText: true,
    //     items: 2,
    //     responsive: {
    //         0: {
    //             items: 2,
    //             loop: true
    //         },
    //         600: {
    //             items: 3
    //         },
    //         1000: {
    //             items: 6
    //         }
    //     }
    // });


    // addCarousel('.pink-promo section', { items: 1 });

    // addCarousel('.quick-links-custom', {
    //     loop: false,
    //     margin: 0,
    //     nav: false,
    //     dots: true,
    //     navText: true,
    //     items: 2,
    //     responsive: {
    //         0: {
    //             items: 2,
    //             loop: true
    //         },
    //         600: {
    //             items: 3
    //         },
    //         1000: {
    //             items: 6
    //         }
    //     }
    // });
    document.querySelector('section.pink-promo-inner') && document.querySelector('section.pink-promo-inner').classList.toggle('hideEl');
  }
});